import styled from 'styled-components';
import { Button } from '@simplywallst/ui-core';
import StarOutline from '@simplywallst/ui-core/icons/StarOutline';
import StarSolid from '@simplywallst/ui-core/icons/StarSolid';

const withOpacity = (C: typeof StarSolid | typeof StarOutline) => styled(C)<{
  opacity?: number;
}>`
  &&& {
    opacity: ${({ opacity = 1 }) => opacity};
  }
`;

export const StarSolidSVG = withOpacity(StarSolid);
export const StarOutlineSVG = withOpacity(StarOutline);

export const MinimalButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ theme }) => theme.x5spacePx}px;
  border-radius: 99999px;
  margin-top: -4px;
  margin-bottom: -4px;

  &&& {
    box-shadow: none;
  }
`;
